import React from 'react';
import { Box } from '@mui/material';
import styled from '@emotion/styled';
import { isMobile } from 'react-device-detect';

const IndicatorRow = styled(Box)({
    position: 'relative' as const,
    display: 'inline-flex',
    alignItems: 'center',
    gap: isMobile ? '4px' : '6px',
});

const IndicatorCircle = styled(Box, {
    shouldForwardProp: (prop) => prop !== '$positionType'
})<{ $positionType: 'D' | 'BB' | 'SB' | 'UTG' }>(({ $positionType }) => ({
    width: isMobile ? '20px' : '24px',
    height: isMobile ? '20px' : '24px',
    borderRadius: '50%',
    backgroundColor: $positionType === 'D' ? '#A7223B' : $positionType === 'BB' ? '#6521AA' : '#B2107B',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: $positionType === 'D' ? (isMobile ? '12px' : '14px') : '10px',
    fontWeight: 'bold',
    fontFamily: '"Inter", serif',
    color: 'white',
    flex: '0 0 auto',
}));

interface PositionIndicatorProps {
    isDealer: boolean;
    isBigBlind: boolean;
    isSmallBlind: boolean;
    isUTG?: boolean;
}

const PositionIndicator: React.FC<PositionIndicatorProps> = ({ isDealer, isBigBlind, isSmallBlind }) => {
    return (
        <IndicatorRow>
            {isDealer && <IndicatorCircle $positionType="D">D</IndicatorCircle>}
            {isBigBlind && <IndicatorCircle $positionType="BB">BB</IndicatorCircle>}
            {isSmallBlind && <IndicatorCircle $positionType="SB">SB</IndicatorCircle>}
        </IndicatorRow>
    );
};

export default PositionIndicator;
